export const AppMenus = {
  navbarTopRightItems: [],
  navbarTopLeftItems: [],
  navbarSideLeftItems: [
    {
      to: "/home",
      label: "Home",
      icon: "pi pi-home mr-2 text-primary",
      iconcolor: "",
      target: "",
    },
    {
      to: "/fund_applications",
      label: "Applications",
      icon: "pi pi-id-card mr-2 text-primary",
      iconcolor: "",
      target: "",
    },
    {
      to: "/third_party_agencies_grants",
      label: "Funding Catalogue",
      icon: "pi pi-star mr-2 text-primary",
      iconcolor: "",
      target: "",
    },
    {
      to: "/third_party_agencies_accounts",
      label: "Accounts",
      icon: "pi pi-users mr-2 text-primary",
      iconcolor: "",
      target: "",
    },
    {
      to: "/info/help",
      label: "Help and Support",
      icon: "pi pi-question-circle mr-2 text-primary",
      iconcolor: "",
      target: "",
    },
  ],
  yes_or_noItems: [
    { value: "Yes", label: "Yes" },
    { value: "No", label: "No" },
  ],
  datatypeItems: [
    { value: "Text", label: "Text" },
    { value: "Number", label: "Number" },
    { value: "Dropdown", label: "Dropdown" },
    { value: "Radio", label: "Radio" },
    { value: "Date", label: "Date" },
  ],
  account_typeItems: [
    { value: "Administrator", label: "Administrator" },
    { value: "Manager", label: "Manager" },
    { value: "Clerk", label: "Clerk" },
    { value: "Agent", label: "Agent" },
  ],
  account_statusItems: [
    { value: "Active", label: "Active" },
    { value: "Inactive", label: "Inactive" },
    { value: "Blocked", label: "Blocked" },
  ],
  grant_typeItems: [
    { value: "Scholarship", label: "Scholarship" },
    { value: "Fund", label: "Fund" },
    { value: "Student Loan", label: "Student Loan" },
  ],
  fund_applicationsgenderItems: [
    { label: "Male", value: "Male" },
    { label: "Female", value: "Female" },
  ],
  fund_applicationsapplicant_in_schoolItems: [
    {
      label: "Successful enrollments",
      value: "Yes",
    },
    { label: "Pending enrollments", value: "No" },
  ],
  fund_applicationsapproval_statusItems: [
    { label: "Approved", value: "Approved" },
    { label: "Declined", value: "Declined" },
    { label: "Pending", value: "Pending" },
  ],

  exportFormats: {
    print: {
      label: "Print",
      icon: "pi pi-print",
      type: "print",
      ext: "",
    },
    pdf: {
      label: "Pdf",

      icon: "pi pi-file-pdf",
      type: "pdf",
      ext: "pdf",
    },
    excel: {
      label: "Excel",
      icon: "pi pi-file-excel",
      type: "excel",
      ext: "xlsx",
    },
    csv: {
      label: "Csv",
      icon: "pi pi-table",
      type: "csv",
      ext: "csv",
    },
  },
};
